import apiClient from "../../api/api";

/**
 * @description Creates a new audit log entry.
 *
 * @async
 * @function requestCreateAuditLog
 * @param {Object} log - The audit log payload to be created.
 *
 * @returns {Promise<any>} A promise that resolves with the created audit log data.
 *
 */
export const requestCreateAuditLog = async(log) => {
    const createLogResponse = await apiClient.post(import.meta.env.VITE_BASE_AUDIT_URL, log)

    return createLogResponse.data
}

/**
 * @description Retrieves a list of audit logs with pagination.
 *
 * @async
 * @function requestGetAuditLogs
 *
 * @returns {Promise<any>} A promise that resolves with the list of audit logs.
 *
 */
export const requestGetAuditLogs = async(startDate, endDate, page = 1, rows = 25) => {
    const params = {
        page: page,
        limit: rows,
        startDate,
        endDate
    }

    const getLogsResponse = await apiClient.get(import.meta.env.VITE_BASE_AUDIT_URL, { params })

    return getLogsResponse.data
}

/**
 * @description Deletes an audit log entry by its unique identifier.
 *
 * @async
 * @function requestDeleteAuditLog
 * @param {number|string} id - The unique identifier of the audit log to be deleted.
 *
 * @returns {Promise<any>} A promise that resolves with the delete operation result.
 *
 */
export const requestDeleteAuditLog = async(id) => {
    const deleteLogResposne = await apiClient.delete(import.meta.env.VITE_BASE_AUDIT_URL+`/${id}`)

    return deleteLogResposne.data
}